import axiosClient from 'utils/axiosClient';
import api from 'api';
import {formData} from 'utils/helpers/formData';

const getGraduates = async (params: any) => {
	const response = await axiosClient.get(api.GRADUATES.GRADUATES, {params});
	return response.data;
};

const getGraduateByID = async (graduateID: number, params?: any) => {
	const response = await axiosClient.get(api.GRADUATES.GRADUATES_BY_ID + graduateID, {params});
	return response.data;
};

const addGraduate = async (data: any, studentID: number) => {
	const response = await axiosClient.post(api.GRADUATES.GRADUATES, data);
	return response.data;
};

const updateGraduate = async (data: any, graduateID: number) => {
	const response = await axiosClient.patch(api.GRADUATES.GRADUATES_BY_ID + graduateID, data);
	return response.data;
};

const uploadGraduates = async (data: any) => {
	const response = await axiosClient.post(api.GRADUATES.GRADUATES_UPLOAD, formData(data), {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
	return response.data;
};

const getGraduateDocuments = async (params: any) => {
	const response = await axiosClient.get(api.GRADUATES.GRADUATES_DOCUMENTS, {params});
	return response.data;
};

const addGraduateDocuments = async (data: any, graduateID: number) => {
	const response = await axiosClient.post(
		api.GRADUATES.GRADUATES_DOCUMENTS,
		formData({...data, graduateID})
	);
	return response.data;
};

const updateGraduateDocuments = async (data: any, documentID: number) => {
	const response = await axiosClient.patch(
		api.GRADUATES.GRADUATES_DOCUMENTS_BY_ID + documentID,
		formData(data),
		{
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}
	);
	return response.data;
};

const deleteGraduateDocuments = async (documentID: number) => {
	const response = await axiosClient.delete(api.GRADUATES.GRADUATES_DOCUMENTS_BY_ID + documentID);
	return response.data;
};

const deleteGraduate = async (graduateID: number) => {
	const response = await axiosClient.delete(api.GRADUATES.GRADUATES_BY_ID + graduateID);
	return response.data;
};

const GRADUATES = {
	getGraduates,
	getGraduateByID,
	addGraduate,
	updateGraduate,
	uploadGraduates,
	getGraduateDocuments,
	addGraduateDocuments,
	updateGraduateDocuments,
	deleteGraduateDocuments,
	deleteGraduate
};

export default GRADUATES;
